// @ts-nocheck
class UserTokens {
    idToken: string = ""
    accessToken: string = ""
    constructor(
        idToken?: string,
        accessToken?: string,
    ) {
        if (idToken) this.idToken = idToken
        if (accessToken) this.accessToken = accessToken
    }
}

export default UserTokens